import React from 'react'
import { Box } from '@chakra-ui/react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuthStore } from 'store/auth.store'
import CheckInView from 'views/admin/check-in/index.jsx'

export default function GateKeeperLayout () {
  const { user, isLoggedIn, token } = useAuthStore()

  // Strict Authentication Check
  if (!isLoggedIn || !token || !user) {
    return <Navigate to='/auth/sign-in' replace />
  }

  // Strict Role Check - ONLY gate_keeper allowed here
  const role = user?.role ? String(user.role).trim().toLowerCase() : ''
  if (role !== 'gate_keeper') {
    if (role === 'admin') {
      return <Navigate to='/admin/check-in' replace />
    }
    return <Navigate to='/auth/sign-in' replace />
  }

  return (
    <Box minH='100vh' bg='#0a0f1d' w='100%' position='relative' overflowX='hidden'>
      <Routes>
        <Route path='check-in' element={<CheckInView isMobileAppView={true} />} />
        <Route path='*' element={<Navigate to='/gatekeeper/check-in' replace />} />
      </Routes>
    </Box>
  )
}
